/**
 * Study line state slice - the line currently on the board, so "Restart" can put it back.
 * The practice itself (moves, verdicts, result) lives in the `practice` slice.
 */
export const studyLineSlice = {
    name: null,       // Line name (e.g., "Sicilian Dragon")
    baseFen: null,    // Starting FEN of the line (null = the initial position)
    uciMoves: null,   // UCI moves to reach the line's position (space-separated)
    routine: null,    // The line is today's opening: how far the day's plays are (components/routine/RoutineBar.tsx)
};
